import gql from 'graphql-tag'

export default gql`{
  annual_leave_this_week{
    id
    user{
      user_id
      full_name
      office_id
    }
    start_date
    start_of_day
    end_date
    end_of_day
  }
}`
